import React, {useState} from "react";
import {useParams} from "react-router-dom";

import {fetchCourseSurvey} from "../../../api/SurveyAPI.js";
import SurveyEditor from "../../../components/adhara/admin/survey/SurveyEditor.js";
import SurveyResponses from "../../../components/adhara/admin/survey/SurveyResponses.js";
import APIFetcher from "../../../components/loading/APIFetcher.js";
import AdminCourseLayout from "../../../layouts/AdminCourseLayout.js";

const ManageCourseSurvey = () => {
    const { courseId } = useParams();

    const [survey, setSurvey] = useState({});

    const fetchItems = () => fetchCourseSurvey(courseId).then(setSurvey)

    return (
        <AdminCourseLayout courseId={courseId}>
            <APIFetcher fetchItems={fetchItems}>
                <SurveyResponses survey={survey}/>
                <SurveyEditor
                    sections={survey.sections} surveyId={survey.id}
                    onChange={(edit) => setSurvey(prev => ({...prev, sections: edit(prev.sections)}))}
                />
            </APIFetcher>
        </AdminCourseLayout>
    )
}


export default ManageCourseSurvey;